import React from 'react';
import { string, func } from 'prop-types';
import {
  Button,
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';

import {
  MeetingContextMeetingControlsProps,
  withMeetingContext,
} from 'Scenes/_root/meetingContext';

const Transition = React.forwardRef((props, ref) => <Slide ref={ref} direction='down' {...props} />);

export const MeetingProtector = ({
  meetingControls,
  message,
  canLeave,
  onClose,
}) => {
  const leave = () => {
    meetingControls.stop();
    canLeave(true);
    onClose();
  };
  return (
    <Dialog
      open
      onClose={leave}
      TransitionComponent={Transition}
    >
      <DialogTitle>Warning!</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            canLeave(false);
            onClose();
          }}
        >
          No, stay
        </Button>
        <Button
          color="primary"
          onClick={leave}
          variant='contained'
        >
          Yes, leave
        </Button>
      </DialogActions>
    </Dialog>
  );
};

MeetingProtector.propTypes = {
  message: string.isRequired,
  canLeave: func.isRequired,
  onClose: func.isRequired,
  meetingControls: MeetingContextMeetingControlsProps,
};

export default withMeetingContext(['meetingControls'])(MeetingProtector);
